import { Outlet } from 'react-router-dom'

const Promo = () => <Outlet />

export default Promo
